import getBasePath from '../functions/api-resource';

const basePath = getBasePath('planejamento_acao', 'acao/relatorio');

const resources = {
};

export default (resource) => resource(`${basePath}`, {}, resources);
